import { ShieldCheck } from 'lucide-react';

import type { IHomeBanner } from '../ui/HomeBanner';

export const organizationStatusMap: Record<string, Omit<IHomeBanner, 'className' | 'subtitle'>> = {
  empty: {
    title: {
      text: 'Welcome to Codekeeper',
    },
    description: 'Set up your software continuity solution below.',
    bgColor: 'bg-[#CAFDF7]',
  },
  backup: {
    title: {
      text: 'Ready for Resilience',
      weight: 'bold' as const,
    },
    textColor: 'white' as const,
    description: 'Your organization is continuously protected with automatic, up-to-date backups.',
    bgColor: 'bg-accent-software-backup',
    icon: ShieldCheck,
  },
  softwareEscrow: {
    title: {
      text: 'Ready for Recovery',
      weight: 'bold' as const,
    },
    textColor: 'white' as const,
    description: 'Your organization has all your required assets ready for quick recovery.',
    bgColor: 'bg-accent-software-escrow',
    icon: ShieldCheck,
  },
  saasEscrow: {
    title: {
      text: 'Ready for Recovery',
      weight: 'bold' as const,
    },
    textColor: 'white' as const,
    description: 'Your organization has all your required assets ready for quick recovery.',
    bgColor: 'bg-accent-saas-escrow',
    icon: ShieldCheck,
  },
  continuity: {
    title: {
      text: 'Ready for Continuity',
      weight: 'bold' as const,
    },
    textColor: 'white' as const,
    description: 'Your organization has continuity protection for cloud-native applications.',
    bgColor: 'bg-accent-continuity-escrow',
    icon: ShieldCheck,
  },
};
